module.exports = __webpack_public_path__ + "assets/5df923e9b3750a3e4862b73189c3f779.png";